import React, { useState, useCallback, useMemo } from 'react';
import $i18n from '../../i18n';
import styles from './index.module.less';
import LoginForms from './component/loginForms';
import LoginFormsCode from './component/loginFormsCode';
// import Requests from '@/services/request';
import RegisterForms from './component/register';
import ForgotPassword from './component/forgotPassword';
// import Copyright from '@/components/Copyright';
// import backgroundImg from '@/assets/login/signup.svg'
// import triangleImg from '@/assets/login/triangle.svg';
import { getQueryStringArgs } from '@/utils/url-parse';
import { COPYRIGHT, isPublicDeploy, LOGINPAGETITLE, LOGINPAGEDESC } from '@/utils/config';
import LocaleSwitch from '@/components/LocaleSwitch';
import { getImages } from '@/utils/theme';

import './index.less';

type type = 'login' | 'forgotPassword' | 'signUp';

const Login: React.FC = () => {
  const isEn = $i18n.language === 'en-US';

  // 切换登录和注册
  // const [isLogin, setIsLogin] = useState<boolean>(true);
  const { type: pagePage } = getQueryStringArgs();
  const [type, setType] = useState(pagePage || 'login');
  // 修改登录注册状态
  const changeToLogin = () => {
    // setIsLogin(!isLogin)
    setType('login');
  };

  const typeComponent = useCallback(() => {
    switch (type) {
      case 'signUp':
        return {
          footerText: (
            <div
              onClick={() => {
                setType('login');
              }}
            >
              {$i18n.get({
                id: 'aopf.pages.login.switchLogin',
                dm: '已有账号? 去登录',
              })}
            </div>
          ),

          component: <RegisterForms changeIsLogin={changeToLogin} />,
        };

      case 'forgotPassword':
        return {
          footerText: (
            <div
              onClick={() => {
                setType('login');
              }}
            >
              {$i18n.get({
                id: 'aopf.pages.login.forgotPassword.backToLogin',
                dm: '返回登录',
              })}
            </div>
          ),

          component: <ForgotPassword changeIsLogin={changeToLogin} />,
        };

      default:
        return {
          footerText: (
            <div
              onClick={() => {
                setType('signUp');
              }}
            >
              {$i18n.get({
                id: 'aopf.pages.login.switchRegistration',
                dm: '没有账号? 去注册',
              })}
            </div>
          ),

          component: window?.__SUPERAPP_CONFIG__?.enforceDynamicPassword ? (
            <LoginFormsCode>
              <div
                className="forgotPassword-container"
                onClick={() => {
                  setType('forgotPassword');
                }}
              >
                {$i18n.get({
                  id: 'aopf.pages.login.forgotPassword',
                  dm: '忘记密码？',
                })}
              </div>
            </LoginFormsCode>
          ) : (
            <LoginForms>
              <div
                className="forgotPassword-container"
                onClick={() => {
                  setType('forgotPassword');
                }}
              >
                {$i18n.get({
                  id: 'aopf.pages.login.forgotPassword',
                  dm: '忘记密码？',
                })}
              </div>
            </LoginForms>
          ),
        };
    }
  }, [type]);

  const loginBg = useMemo(() => {
    return getImages().loginBg;
  }, [window.__SUPERAPP_CONFIG__?.themeColors]);

  return (
    <>
      <div className={styles.container}>
        <LocaleSwitch />
        {/* <img src={triangleImg} alt="" className={styles.loginTriangleImg} /> */}
        <div className={styles.left}>
          <div className={styles.title}>
            {LOGINPAGETITLE}
          </div>
          <div className={styles.subTitle} style={{ width: isEn ? '700px' : '600px' }}>
            {LOGINPAGEDESC}
          </div>
          <div style={{ width: 843, height: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            <img
              // src={
              //   window.__SUPERAPP_CONFIG__?.loginPage?.image ||
              //   'https://img.alicdn.com/imgextra/i1/O1CN01PwTes41doCizHJK48_!!6000000003782-2-tps-1686-1124.png'
              // }
              src={window.__SUPERAPP_CONFIG__?.loginPage?.image || loginBg}
              style={{ width: 843, height: 'auto' }}
            />
          </div>
          <div className={styles.copyright}>
            <div>{COPYRIGHT}</div>
            {isPublicDeploy() && (
              <div>
                <a
                  // href={`https://www.alibabacloud.com/help/${
                  //   isEn ? 'en' : 'zh'
                  // }/legal/latest/alibaba-cloud-international-website-privacy-policy-v3`}
                  onClick={() =>
                    window.open(
                      'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-privacy-policy',
                    )
                  }
                >
                  {$i18n.get({ id: 'aopf.pages.login.PrivacyPolicy', dm: 'Privacy Policy' })}
                </a>
                &nbsp;|&nbsp;
                <a
                  // href={`https://www.alibabacloud.com/help/${
                  //   isEn ? 'en' : 'zh'
                  // }/legal/latest/alibaba-cloud-international-website-terms-of-use-alibaba-cloud-international-website-terms-of-use`}
                  onClick={() =>
                    window.open(
                      'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-terms-of-use-alibaba-cloud-international-website-terms-of-use',
                    )
                  }
                >
                  {$i18n.get({ id: 'aopf.pages.login.WebsiteTermsOfUse', dm: 'Terms of Use' })}
                </a>
                &nbsp;|&nbsp;
                <a
                  // href={`https://www.alibabacloud.com/help/${
                  //   isEn ? 'en' : 'zh'
                  // }/legal/latest/alibaba-cloud-international-website-membership-agreement`}
                  onClick={() =>
                    window.open(
                      'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-membership-agreement',
                    )
                  }
                >
                  {$i18n.get({
                    id: 'aopf.pages.login.MembershipServiceAgreement',
                    dm: 'Membership Agreement',
                  })}
                </a>
                &nbsp;|&nbsp;
                <a
                  // href={`https://www.alibabacloud.com/help/${
                  //   isEn ? 'en' : 'zh'
                  // }/legal/latest/alibaba-cloud-international-website-product-terms-of-service`}
                  onClick={() =>
                    window.open(
                      'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-product-terms-of-service',
                    )
                  }
                >
                  {$i18n.get({ id: 'aopf.pages.login.ProductTerms', dm: 'Product Terms' })}
                </a>
              </div>
            )}
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.form}>
            {typeComponent().component}
            <div className={styles.switch}>
              {type === 'login' && window.__SUPERAPP_CONFIG__?.loginUrl ? (
                <div
                  onClick={() => {
                    const { redirect } = getQueryStringArgs();
                    window.location.href = `${window.__SUPERAPP_CONFIG__?.loginUrl}${
                      redirect || encodeURIComponent(`${window.location.origin}/superapp`)
                    }`;
                  }}
                >
                  {$i18n.get({ id: 'aopf.pages.login.AlibabaCloudLogon', dm: '登录阿里云账号' })}
                </div>
              ) : null}
              {typeComponent().footerText}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
